import React from "react";

const SectionCard = ({ icon, title, subtitle, trailing, children, id }) => {
  return (
    <section className="pf-card" id={id}>
      <header className="pf-card__head">
        {icon ? <span className="pf-card__icon">{icon}</span> : null}
        <div>
          <h3 className="pf-card__title">{title}</h3>
          {subtitle ? <div className="pf-card__subtitle">{subtitle}</div> : null}
        </div>
        {trailing ? <div className="pf-card__trailing">{trailing}</div> : null}
      </header>
      <div className="pf-card__body">{children}</div>
    </section>
  );
};

export default SectionCard;
